import React from 'react';

interface Props {
  className?: string;
}

export function IconTiktok(props: Props) {
  const { className = '' } = props;

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
    >
      <g clipPath="url(#clip0_4626_151240)">
        <path
          d="M16 0C7.16481 0 0 7.16481 0 16C0 24.8352 7.16481 32 16 32C24.8352 32 32 24.8352 32 16C32 7.16481 24.8352 0 16 0ZM24.0269 12.2421V14.4085C23.0053 14.4089 22.0128 14.2087 21.0766 13.8138C20.4747 13.5596 19.9139 13.2322 19.4009 12.8365L19.4163 19.5048C19.4099 21.0064 18.8158 22.4172 17.7406 23.4799C16.8656 24.3449 15.7569 24.8949 14.5551 25.073C14.2727 25.1148 13.9854 25.1362 13.6947 25.1362C12.4083 25.1362 11.187 24.7195 10.1879 23.9506C9.99994 23.8059 9.82012 23.6489 9.64894 23.4799C8.48369 22.3282 7.88281 20.7673 7.984 19.1252C8.06119 17.8753 8.56162 16.6833 9.39587 15.7489C10.4996 14.5126 12.0437 13.8263 13.6947 13.8263C13.9854 13.8263 14.2727 13.8481 14.5551 13.8899V14.6909V16.9192C14.2874 16.8309 14.0014 16.7823 13.7037 16.7823C12.1953 16.7823 10.975 18.0129 10.9976 19.5224C11.0119 20.4883 11.5394 21.3325 12.3176 21.7979C12.6832 22.0166 13.1039 22.1521 13.5529 22.1768C13.9046 22.1961 14.2424 22.1471 14.5551 22.0438C15.6328 21.6878 16.4102 20.6756 16.4102 19.4817L16.4138 15.0162V6.86375H19.3973C19.4002 7.15938 19.4302 7.44781 19.4859 7.72731C19.7111 8.85863 20.3488 9.84013 21.2363 10.5092C22.0102 11.0929 22.9738 11.4389 24.0182 11.4389C24.0189 11.4389 24.0276 11.4389 24.0268 11.4382V12.2421H24.0269Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_4626_151240">
          <rect width={32} height={32} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
